import axios from 'axios';
// Importer le service d'impression
import printerService from './printerService';

const API_URL = '/api/tickets';

/**
 * Service pour gérer les opérations liées aux tickets
 */
const ticketService = {
 
  /**
 * Créer un nouveau ticket
 * @param {string} serviceType - Type de service (P, C, S, etc.)
 * @param {boolean} priority - Indique si le ticket est prioritaire
 * @param {boolean} printTicket - Indique si le ticket doit être imprimé automatiquement
 * @returns {Promise} Promesse résolue avec les données du ticket créé
 */ 
createTicket: async (serviceType, priority = false, printTicket = true) => {
  try {
    const response = await axios.post(API_URL, { serviceType, priority });
    
    // Si la création du ticket est réussie et que l'impression est demandée
    if (response.data.success && printTicket) {
      try {
        // Tenter d'imprimer le ticket
        await printerService.printTicket(
          response.data.data.ticketId,
          serviceType
        );
      } catch (printError) {
        console.error('Erreur lors de l\'impression du ticket:', printError);
        // Ne pas échouer la création du ticket si l'impression échoue
      }
    }
    
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la création du ticket:', error);
    throw error;
  }
},

  /**
   * Récupérer tous les tickets actifs (en attente et en service)
   * @returns {Promise} Promesse résolue avec la liste des tickets actifs
   */
  getActiveTickets: async () => {
    try {
      const response = await axios.get(`${API_URL}/active`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des tickets actifs:', error);
      throw error;
    }
  },

  // // // // getAllCompletedTickets: async () => {
  // // // //   try {
  // // // //     const response = await axios.get(`${API_URL}/all-completed`);
  // // // //     return response.data;
  // // // //   } catch (err) {
  // // // //     console.error('Erreur lors du chargement des tickets complétés :', err);
  // // // //     throw err;
  // // // //   }
  // // // // },
  getAllCompletedTickets: async ({ userId, startDate, endDate, all = false }) => {
    try {
      const params = {};

      if (userId) params.userId = userId;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (all) params.all = true;

      const response = await axios.get(`${API_URL}/all-completed`, { params });
      return response.data;
    } catch (err) {
      console.error('Erreur lors du chargement des tickets filtrés :', err);
      throw err;
    }
  },
  
  /**
   * Récupérer tous les tickets en attente, éventuellement filtrés par type de service
   * @param {string} serviceType - Type de service à filtrer (optionnel)
   * @returns {Promise} Promesse résolue avec la liste des tickets en attente
   */
  getWaitingTickets: async (serviceType = null) => {
    try {
      const url = serviceType ? `${API_URL}/waiting/${serviceType}` : `${API_URL}/waiting`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des tickets en attente:', error);
      throw error;
    }
  },

  /**
   * Appeler le prochain ticket pour un guichet
   * @param {number} counterId - ID du guichet
   * @param {string} serviceType - Type de service à appeler
   * @returns {Promise} Promesse résolue avec les données du ticket appelé
   */
  callNextTicket: async (counterId, serviceType) => {
    try {
      const response = await axios.post(`${API_URL}/call/${counterId}`, { serviceType });
      // FILE VIDE = 204 No Content, donc un corps VIDE. `response.data` valait alors la
      // chaîne vide, `data.success` était `undefined`, et le guichet affichait « Erreur lors
      // de l'appel du prochain ticket » — un bandeau rouge pour le cas le plus normal de la
      // journée : plus personne n'attend. On distingue explicitement le refus de la panne.
      if (response.status === 204) return { success: true, data: null, fileVide: true };
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'appel du prochain ticket:', error);
      throw error;
    }
  },

  /**
   * Appeler un ticket PRÉCIS par son numéro d'ordre global.
   *
   * Ce n'est pas un confort : quand un client se présente au guichet avec son papier
   * alors que son tour est passé — il n'a pas entendu, il était sorti — le guichetier
   * n'a aujourd'hui aucun moyen de le reprendre sans vider la file devant lui. Le
   * serveur répond par un message circonstancié quand le ticket n'est plus appelable
   * (déjà servi, annulé, en cours ailleurs) : on le remonte tel quel au guichetier,
   * c'est lui qui parle au client.
   *
   * @param {number} counterId - guichet appelant
   * @param {number} globalNumber - numéro d'ordre global figurant sur le ticket
   */
  callGlobalTicket: async (counterId, globalNumber) => {
    const response = await axios.post(`${API_URL}/call-global/${counterId}`, {
      globalNumber: Number(globalNumber),
    });
    return response.data;
  },

  /**
   * Terminer le service d'un ticket
   * @param {string} ticketId - ID du ticket à terminer
   * @returns {Promise} Promesse résolue avec les données du ticket terminé
   */
  completeTicket: async (ticketId) => {
    // Vérifier si le ticketId est valide
    if (!ticketId) {
      throw new Error('ID de ticket invalide');
    }
    console.log('ticketId :', ticketId);

    // Vérifier si le ticketId est un UUID valide
    // if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(ticketId)) {
    //   throw new Error('ID de ticket doit être un UUID valide');
    // } 


    try { 
      const token = localStorage.getItem('token');
      console.log('token :', token);
const url =   `${API_URL}/complete/${ticketId}`;
console.log('url  :', url);
      // Vérifier si le token est valide
      console.log('url  :', ticketId);
      // Appeler l'API pour terminer le service du ticket
      const response = await axios.put(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      console.log('response :', response);
      // Vérifier si la réponse est valide
      if (!response || !response.data) {
        throw new Error('Réponse invalide du serveur');
      }
      // Vérifier si le ticket a été trouvé
      if (!response.data.success) {
        throw new Error('Ticket non trouvé ou déjà terminé');
      }
      // Vérifier si la réponse contient une erreur
      if (response.data.error) {
        throw new Error(response.data.error);
      }
     
      // Retourner les données du ticket terminé
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la fin du service:', error);
      throw error;
    }
  },

  /**
   * Annuler un ticket
   * @param {string} ticketId - ID du ticket à annuler
   * @returns {Promise} Promesse résolue avec les données du ticket annulé
   */
  cancelTicket: async (ticketId) => {
    try {
      const response = await axios.put(`${API_URL}/cancel/${ticketId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'annulation du ticket:', error);
      throw error;
    }
  },

  /**
   * Récupérer les statistiques des tickets
   * @param {string} date - Date pour laquelle récupérer les statistiques (format: YYYY-MM-DD)
   * @returns {Promise} Promesse résolue avec les statistiques des tickets
   */
  getTicketStats: async (date = null) => {
    try {
      const url = date ? `${API_URL}/stats?date=${date}` : `${API_URL}/stats`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques:', error);
      throw error;
    }
  },

  /**
   * Récupérer les temps d'attente moyens par service
   * @param {string} startDate - Date de début (format: YYYY-MM-DD)
   * @param {string} endDate - Date de fin (format: YYYY-MM-DD)
   * @returns {Promise} Promesse résolue avec les temps d'attente moyens
   */
  getAverageWaitTimes: async (startDate = null, endDate = null) => {
    try {
      let url = `${API_URL}/wait-times`;
      
      if (startDate || endDate) {
        url += '?';
        if (startDate) url += `startDate=${startDate}`;
        if (startDate && endDate) url += '&';
        if (endDate) url += `endDate=${endDate}`;
      }
      
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des temps d\'attente moyens:', error);
      throw error;
    }
  },

  /**
   * Rappeler un ticket déjà appelé
   * @param {string} ticketId - ID du ticket à rappeler
   * @returns {Promise} Promesse résolue avec les données du ticket rappelé
   */
  recallTicket: async (ticketId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/recall/${ticketId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Erreur lors du rappel du ticket:', error);
      throw error;
    }
  },

  /**
   * Mettre en pause le service d'un ticket en cours
   * @param {string} ticketId - ID du ticket à mettre en pause
   * @param {string} reason - Raison de la pause
   * @returns {Promise} Promesse résolue avec les données du ticket en pause
   */
  pauseTicketService: async (ticketId, reason = 'Pause demandée par l\'agent') => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${API_URL}/pause/${ticketId}`,
        { reason },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la pause du service:', error);
      throw error;
    }
  },

  /**
   * Reprendre le service d'un ticket en pause
   * @param {string} ticketId - ID du ticket à reprendre
   * @returns {Promise} Promesse résolue avec les données du ticket repris
   */
  resumeTicketService: async (ticketId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${API_URL}/resume/${ticketId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la reprise du service:', error);
      throw error;
    }
  }
};

export default ticketService;
